import styles from './ThreadOutline.module.scss';

interface OutlineQuestion {
	// The question as the user typed it.
	text: string;
	// Its position in the thread, used to scroll back to it.
	idx: number;
}

interface ThreadOutlineProps {
	questions: OutlineQuestion[];
	activeIndex: number | null;
	onJump: (index: number) => void;
}

// A map of the questions asked so far, living in the empty gutter to the right
// of the conversation.
//
// Two rules about where it appears, both deliberate. It only shows from two
// questions up — a rail listing one item is noise, not navigation. And CSS
// hides it below 1560px wide, where the gutter is too narrow to hold it
// without squeezing the reading column, which is the whole reason that space
// is empty in the first place.
const ThreadOutline = ({ questions, activeIndex, onJump }: ThreadOutlineProps) => {
	if (questions.length < 2) {
		return null;
	}

	return (
		<nav className={styles.outline} aria-label="Questions in this chat">
			<p className={styles.outline__title}>In this chat</p>
			<ol className={styles.outline__list}>
				{questions.map((question) => {
					const active = question.idx === activeIndex;
					return (
						<li key={question.idx}>
							<button
								type="button"
								className={`${styles.outline__item} ${active ? styles['outline__item--on'] : ''}`}
								aria-current={active ? 'true' : undefined}
								title={question.text}
								onClick={() => onJump(question.idx)}
							>
								{question.text}
							</button>
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export default ThreadOutline;
